import React, { useEffect, createContext, useContext, useState } from 'react';

const AuthenticationContext = createContext();

export function useAuthentication() {
  return useContext(AuthenticationContext);
};

export default function AuthenticationProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(() =>
    sessionStorage.getItem("isAuthenticated") === 'true'
  );
  const [account, setAccount] = useState(JSON.parse(sessionStorage.getItem("account")));
  const [company, setCompany] = useState(null);

  const login = () => {
    setIsAuthenticated(true);
  }

  const logout = () => {
    setIsAuthenticated(false);
  }

  useEffect(() => {
    if (isAuthenticated) {
      sessionStorage.setItem("isAuthenticated", isAuthenticated);
    }
    if (account) {
      sessionStorage.setItem("account", JSON.stringify(account));
      
      setCompany(account.profile.company);
    }

  }, [isAuthenticated, account]);
  
  return (
    <AuthenticationContext.Provider value={{ isAuthenticated,  login, logout, account, company, setAccount }}>
      {children}
    </AuthenticationContext.Provider>
  );
};
